// This file is auto-generated by @oracle/oraclejet-icu-l10n from src/resources/icu/bundle.json
// and should not be edited by hand. Update the JSON file and rerun the build to regenerate this content.

const bundle = {
  calendarDateConverter_parseError: (p: { dateExample: string }) =>
    'Proovige uuesti, kasutades täielikku kuupäeva, nagu see: ' + p['dateExample'] + '.',
  chart_labelGroup: () => 'Rühm',
  chart_labelSeries: () => 'Sari',
  chart_labelValue: () => 'Väärtus',
  checkboxSet_requiredMessageDetail: () => 'Kohustuslik',
  checkbox_requiredMessageDetail: () => 'Kohustuslik',
  close: () => 'Sule',
  collection_noData: () => 'Kuvatavaid andmeid pole.',
  collection_selectAllRows: () => 'Vali kõik read',
  collection_selectRow: (p: { ROW_NAME: string }) => 'Vali rida ' + p['ROW_NAME'],
  collection_sortDisabled: () => 'Mittesorditav',
  collection_sortEnabled: () => 'Sorditav',
  confirmation: () => 'Kinnitus',
  dataVisualization_labelAndValue: (p: { LABEL: string; VALUE: string }) =>
    p['LABEL'] + ': ' + p['VALUE'],
  dataVisualization_labelCountWithTotal: (p: { itemCount: string; totalCount: string }) =>
    p['itemCount'] + '/' + p['totalCount'],
  dataVisualization_noData: () => 'Kuvatavaid andmeid pole',
  dataVisualization_stateSelected: () => 'Valitud',
  dataVisualization_stateUnselected: () => 'Valimata',
  error: () => 'Tõrge',
  expandableList_expandCollapseInstructionText: () =>
    'Kasutage laiendamiseks ja ahendamiseks nooleklahve',
  expandableList_groupCollapse: () => 'Ahendatud',
  expandableList_groupExpand: () => 'Laiendatud',
  filePicker_addFiles: () => 'Lisa failid',
  filePicker_dropzonePrimaryText: () => 'Pukseeri',
  filePicker_dropzoneSecondaryText: () => 'Valige fail või pukseerige see siia',
  filePicker_dropzoneSecondaryTextMultiple: () => 'Valige failid või pukseerige need siia',
  filePicker_multipleFileTypeUploadError: (p: { fileTypes: string }) =>
    'Te ei saa üles laadida faile tüübiga ' + p['fileTypes'],
  filePicker_singleFileUploadError: () => 'Üles saate korraga laadida ühe faili',
  filePicker_singleTypeUploadError: (p: { fileType: string }) =>
    'Te ei saa üles laadida faile tüübiga ' + p['fileType'],
  filePicker_unknownFileTypeUploadError: () => 'tundmatu',
  formControl_clear: () => 'Tühjenda',
  formControl_day: () => 'Päev',
  formControl_helpAvailable: () => 'Spikker on saadaval',
  formControl_limitReached: (p: { CHARACTER_LIMIT: number }) =>
    'Limiit ' +
    (({ one: '1 character' } as Partial<Record<Intl.LDMLPluralRule, string>>)[
      new Intl.PluralRules('et').select(p['CHARACTER_LIMIT'])
    ] || new Intl.NumberFormat('et').format(p['CHARACTER_LIMIT']) + ' characters') +
    ' on täis.',
  formControl_loading: () => 'Laadimine',
  formControl_maxLengthExceeded: (p: { MAX_LENGTH: string }) =>
    'Maksimumpikkus ' + p['MAX_LENGTH'] + ' on ületatud.',
  formControl_maxLengthRemaining: (p: { CHARACTER_COUNT: string }) =>
    'Järele on jäänud ' + p['CHARACTER_COUNT'] + ' märki.',
  formControl_month: () => 'Kuu',
  formControl_readOnly: () => 'Kirjutuskaitstud',
  formControl_requiredMessageDetail: () => 'Sisestage väärtus.',
  formControl_year: () => 'Aasta',
  gantt_labelDate: () => 'Kuupäev',
  gantt_labelEnd: () => 'Lõpp',
  gantt_labelLabel: () => 'Silt',
  gantt_labelRow: () => 'Rida',
  gantt_labelStart: () => 'Algus',
  indexer_disabledLabel: (p: { SECTION: string }) => p['SECTION'] + '. Vastavat jaotist ei leitud.',
  indexer_keyboardInstructionText: () => 'Väärtuse valimiseks vajutage sisestusklahvi.',
  indexer_othersLabel: () => '#',
  indexer_separatorLabel: (p: { FROM_SECTION: string; TO_SECTION: string }) =>
    'Vahemikus ' + p['FROM_SECTION'] + ' ja ' + p['TO_SECTION'] + '.',
  indexer_touchInstructionText: () =>
    'Topeltpuudutage ja hoidke žestirežiimi aktiveerimisekst ning seejärel lohistage väärtuse kohandamiseks üles või alla.',
  info: () => 'Teave',
  inputDateMask_date_cleared: () => 'Kuupäev on eemaldatud',
  inputDateMask_dayPlaceholder: () => 'dd',
  inputDateMask_empty_segment: () => 'Tühi',
  inputDateMask_monthPlaceholder: () => 'mm',
  inputDateMask_yearPlaceholder: () => 'yyyy',
  inputNumber_converterParseError: () => 'Sisestage number.',
  inputNumber_decrease: () => 'Vähendamine',
  inputNumber_increase: () => 'Suurendamine',
  inputPassword_hidden: () => 'Parool on peidetud',
  inputPassword_hide: () => 'Peida parool',
  inputPassword_show: () => 'Kuva parool',
  list_suggestion: () => 'Soovitus',
  messageToast_allMessagesClosed: () => 'Kõik töölaua sõnumid on suletud.',
  message_close: () => 'Sule',
  message_confirmation: () => 'Õnnestus',
  message_error: () => 'Tõrge',
  message_info: () => 'Teave',
  message_navigationFromMessagesRegion: () =>
    'Sõnumite alasse liikumine. Eelmisele fookuses olnud elemendile tagasiliikumiseks vajutage klahvi F6.',
  message_navigationToMessagesRegion: () =>
    'Sõnumite alal on uusi sõnumeid. Viimatise sõnumi alale liikumiseks vajutage klahvi F6.',
  message_warning: () => 'Hoiatus',
  noData_message: () => 'Kuvatavaid üksusi pole',
  overflowItemLabel: () => 'Rohkem vahekaarte',
  plural_separator: () => ', ',
  progressIndeterminate: () => 'Pooleli',
  radio_helpForRadio: () => 'Raadionupu spikker',
  radio_requiredMessageDetail: () => 'Valige väärtus.',
  selectMultiple_apply: () => 'Rakenda',
  selectMultiple_back: () => 'Tagasi',
  selectMultiple_countPlus: (p: { COUNT: string }) => p['COUNT'] + '+',
  selectMultiple_removeSelectedTagInstructionText: () =>
    'Valitud väärtuse eemaldamiseks vajutage tagasilükkeklahvi või klahvi Kustuta.',
  selectMultiple_selectedValues: () => 'Valitud väärtused',
  selectMultiple_showSelectedValues: () => 'Kuva ainult valitud väärtused.',
  selectMultiple_valuesSelected: (p: { VALUE_COUNT: string }) =>
    'Valitud on ' + p['VALUE_COUNT'] + ' väärtust.',
  select_addToList: () => 'Lisa loendisse',
  select_addToListAvailable: () => 'Loendisse lisamine on saadaval',
  select_moreSearchOptions: () => 'Veel otsingusuvandeid',
  select_moreSearchOptionsAvailable: () => 'Saadaval on veel otsingusuvandeid',
  select_noMatchesFound: () => 'Vasteid ei leitud.',
  select_oneMatchFound: () => 'Leiti üks vaste',
  select_requiredMessageDetail: () => 'Valige väärtus.',
  select_sizeMatchesFound: (p: { TOTAL_SIZE: string }) => 'Leiti ' + p['TOTAL_SIZE'] + ' vastet',
  select_sizeOrMoreMatchesFound: (p: { TOTAL_SIZE: string }) =>
    'Leiti ' + p['TOTAL_SIZE'] + ' või rohkem vastet',
  selector_selected: () => 'Märkeruut on märgitud',
  selector_unselected: () => 'Märkeruut pole märgitud',
  tabBarNavigationList_removeCueText: () => 'Eemaldatav',
  timeComponent_tooltipZoomIn: () => 'Suurenda',
  timeComponent_tooltipZoomOut: () => 'Vähenda',
  train_current: () => 'Praegune',
  train_message_type: () => 'Sõnumitüüp',
  train_not_visited: () => 'Pole külastatud',
  train_status: (p: { currentStep: string; numberOfSteps: string }) =>
    'Samm ' + p['currentStep'] + '/' + p['numberOfSteps'],
  train_visited: () => 'Külastatud',
  userAssistance_learnMore: () => 'Lisateave',
  userAssistance_required: () => 'Kohustuslik',
  viz_drillable: () => 'Süvitsiminekuks sobiv',
  warn: () => 'Hoiatus'
};
export default bundle;
